import { notProduction } from '../constants/notProduction';
import { ErrorReportingClient } from '../types/ErrorReportingClient';
import { ErrorReportingDevtools } from '../types/ErrorReportingDevtools';
import { createBreadcrumbDevtool } from './createBreadcrumbDevtool';
import { createClearScopeDevtool } from './createClearScopeDevtool';
import { createFlushDevtool } from './createFlushDevtool';
import { createGetScopeDevtool } from './createGetScopeDevtool';
import { createHelpDevtool } from './createHelpDevtool';
import { createListBreadcrumbsDevtool } from './createListBreadcrumbsDevtool';
import { createSimulateNetworkErrorDevtool } from './createSimulateNetworkErrorDevtool';
import { createTriggerErrorDevtool } from './createTriggerErrorDevtool';

declare global {
  interface Window {
    errorReporting?: ErrorReportingDevtools;
  }
}

const buildDevtools = (
  client: ErrorReportingClient,
): ErrorReportingDevtools => ({
  breadcrumb: createBreadcrumbDevtool(client),
  clearScope: createClearScopeDevtool(client),
  flush: createFlushDevtool(client),
  getScope: createGetScopeDevtool(client),
  help: createHelpDevtool(),
  listBreadcrumbs: createListBreadcrumbsDevtool(client),
  simulateNetworkError: createSimulateNetworkErrorDevtool(client),
  triggerError: createTriggerErrorDevtool(client),
});

/**
 * Expose `window.errorReporting` so QA / engineers can trigger different
 * categories of errors and inspect the data the error-reporting client has
 * buffered locally before it ships. Only installed outside production.
 *
 * Each individual command lives in its own file under this directory -
 * see `README.md` for the full reference.
 */
export const exposeErrorReportingDevtools = (
  client: ErrorReportingClient,
  isNotProduction: boolean = notProduction,
): void => {
  if (typeof window === 'undefined') {
    return;
  }

  if (!isNotProduction) {
    return;
  }

  window.errorReporting = buildDevtools(client);
};
